var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isSandbox)?_c('icon',{directives:[{name:"tooltip",rawName:"v-tooltip:top",value:(_vm.$t("tooltip.sandboxEnvelope")),expression:"$t(\"tooltip.sandboxEnvelope\")",arg:"top"}],class:_vm.icon.class,attrs:{"name":_vm.icon.name}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }